import type { FC } from 'react';
import React from 'react';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import Skeleton from '@atlaskit/skeleton';

export const LoadingState: FC = () => (
	<Box paddingBlock="space.300">
		<Stack
			space="space.300"
			alignBlock="center"
			alignInline="center"
			grow="fill"
			testId="content-menu-loading"
		>
			{[...Array(10)].map((_, index) => (
				<Skeleton key={index} width="250px" height="9px" borderRadius="3px" />
			))}
		</Stack>
	</Box>
);
